import React, { useEffect, useContext } from 'react';
import {RESET_REGISTER_DETAILS} from 'schemas/register';
import { useMutation } from "@apollo/client";
import { Button } from "react-bootstrap";
import RegisterContext from '../../RegisterContext'

export default function AlreadyRegisteredStep({push}) {

  const {user, goToStepsProcess} = useContext(RegisterContext)

  const [reset, {data, error}] = useMutation(RESET_REGISTER_DETAILS)
  function resetDetails() {
    reset()
  }
  useEffect(() => {
    if (data) {
      goToStepsProcess()
    }
  }, [data, error])
  return (
    <>
      <h3>שלום {user.firstName}</h3>
      <p className="medium-font mb-5">זיהינו שהתחלת בתהליך רישום ביום {user.createdAt}
      נוכל לשחזר את הפרטים שכבר הזנת במשלוח סיסמה זמנית לטלפון הנייד
      </p>
      <div>
        <Button  className="btn_submit " aria-label="לשחזור פרטים" variant="dark" onClick={() => push('send_password')}>לשחזור פרטים</Button>
        <Button className="normal-font" aria-label="לא, אתחיל מהתחלה" variant="link" onClick={resetDetails}>לא, אתחיל מהתחלה</Button>
      </div>

    </>
  )
}